import { useWeb3React } from '@web3-react/core';
import useTabsState from '../../components/Tabs/useTabsState';
// import useUserRankings from '../../hooks/analytics/useUserRankings';
import useMockUserRankings from '../../hooks/analytics/useMockUserRankings';
import LeaderboardPnlHeader from './PnL/LeaderboardPnlHeader';
import LeaderboardPnlRow from './PnL/LeaderboardPnlRow';
import LeaderboardVolumeHeader from './Volume/LeaderboardVolumeHeader';
import LeaderboardVolumeRow from './Volume/LeaderboardVolumeRow';
import LeaderboardStatus from './LeaderboardStatus';

type UserRankingProps = {
    dataPerRow: number;
};

const UserRanking: React.FC<UserRankingProps> = ({ dataPerRow }) => {
    const { account } = useWeb3React();
    const { tabIndex } = useTabsState();
    // const { userRankings, userData } = useUserRankings();
    const { userRankings, userData } = useMockUserRankings();

    return (
        <>
            <h1>My Ranking</h1>
            <div className='leaderboard-table user-ranking'>
                {account ? (
                    userRankings && userData ? (
                        tabIndex === 0 ? (
                            <>
                                <LeaderboardPnlHeader />
                                <LeaderboardPnlRow isUserRanking data={userData} />
                            </>
                        ) : (
                            <>
                                <LeaderboardVolumeHeader />
                                <LeaderboardVolumeRow
                                    dataPerRow={dataPerRow}
                                    isUserRanking
                                    data={userData}
                                />
                            </>
                        )
                    ) : (
                        <LeaderboardStatus type='no-trades' />
                    )
                ) : (
                    <LeaderboardStatus type='not-connected' />
                )}
            </div>
        </>
    );
};

export default UserRanking;
